import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

export type DiagramData = {
  title: string;
  content: string;
};

@Injectable({
  providedIn: 'root',
})
export class EditorService {
  private readonly _SESSION_CONTENT_KEY = 'sequence-diagram-text';
  private readonly _SESSION_TITLE_KEY = 'sequence-diagram-title';
  private readonly _DEFAULT_TITLE = 'Titre de mon diagramme';
  private readonly _DEFAULT_DIAGRAM_TEXT = `
actor Utilisateur
entity Frontend
entity Backend
entity Database

Utilisateur -> Frontend: Remplit le formulaire
Frontend -> Backend: POST /submit-form
Backend -> Database: INSERT données utilisateur
Database -> Backend: 200 OK (données enregistrées)
Backend -> Frontend: 201 Created
Frontend -> Utilisateur: Message de succès
 `.trim();

  private _diagramText = new BehaviorSubject<string>(this._getInitialDiagramText());
  private _diagramTitle = new BehaviorSubject<string>(this._getInitialTitle());

  diagramText$ = this._diagramText.asObservable();
  diagramTitle$ = this._diagramTitle.asObservable();

  private _getInitialDiagramText(): string {
    if (typeof Storage === 'undefined') {
      return this._DEFAULT_DIAGRAM_TEXT;
    }
    const sessionText = sessionStorage.getItem(this._SESSION_CONTENT_KEY);
    return sessionText?.trim() || this._DEFAULT_DIAGRAM_TEXT;
  }

  private _getInitialTitle(): string {
    if (typeof Storage === 'undefined') {
      return this._DEFAULT_TITLE;
    }
    const sessionTitle = sessionStorage.getItem(this._SESSION_TITLE_KEY);
    return sessionTitle?.trim() || this._DEFAULT_TITLE;
  }

  setDiagramText(value: string): void {
    this._diagramText.next(value);
    this._saveToSession(this._SESSION_CONTENT_KEY, value);
  }

  setDiagramTitle(value: string): void {
    const title = value.trim();
    this._diagramTitle.next(title);
    this._saveToSession(this._SESSION_TITLE_KEY, title);
  }

  private _saveToSession(key: string, value: string): void {
    if (typeof Storage !== 'undefined') {
      sessionStorage.setItem(key, value);
    }
  }

  getCurrentDiagramText(): string {
    return this._diagramText.value;
  }

  getCurrentDiagramTitle(): string {
    return this._diagramTitle.value;
  }

  getCurrentDiagramData(): DiagramData {
    return {
      title: this.getCurrentDiagramTitle(),
      content: this.getCurrentDiagramText(),
    };
  }
}
